/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  CreateVehicle200Response,
  CreateVehicleRequest,
  DuplicateData,
  InternalServerError,
  NotFound,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
  UpdateVehicleRequest,
  VehiclePaginationResponse,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    CreateVehicle200ResponseFromJSON,
    CreateVehicle200ResponseToJSON,
    CreateVehicleRequestFromJSON,
    CreateVehicleRequestToJSON,
    DuplicateDataFromJSON,
    DuplicateDataToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    NotFoundFromJSON,
    NotFoundToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
    UpdateVehicleRequestFromJSON,
    UpdateVehicleRequestToJSON,
    VehiclePaginationResponseFromJSON,
    VehiclePaginationResponseToJSON,
} from '../models/index';

export interface CreateVehicleOperationRequest {
    createVehicleRequest: CreateVehicleRequest;
}

export interface CreateVehiclesCsvRequest {
    file: Blob;
}

export interface DeleteVehicleRequest {
    ifMatch: number;
    carId: string;
}

export interface GetVehiclesRequest {
    page?: number;
    count?: number;
    sort?: GetVehiclesSortEnum;
    radioNoKeyword?: string;
    carTypeNameKeyword?: string;
    carColorNameKeyword?: string;
    groupNameKeyword?: string;
    companyNameKeyword?: string;
    salesOfficeNameKeyword?: string;
    sortKey?: string;
}

export interface GetVehiclesCsvRequest {
    radioNoKeyword?: string;
    carTypeNameKeyword?: string;
    carColorNameKeyword?: string;
    groupNameKeyword?: string;
    companyNameKeyword?: string;
    salesOfficeNameKeyword?: string;
    sortKey?: string;
    sort?: GetVehiclesCsvSortEnum;
}

export interface UpdateVehicleOperationRequest {
    ifMatch: number;
    carId: string;
    updateVehicleRequest: UpdateVehicleRequest;
}

export interface UpdateVehiclesCsvRequest {
    file: Blob;
}

/**
 * 
 */
export class VehiclesApi extends runtime.BaseAPI {

    /**
     * 指定された車両情報を登録します。<br> 会社・営業所・ナンバープレート・メーターモードなどの情報を元に新しい車両レコードを作成します。<br> 初度登録年月および個人タクシー情報は個人タクシーの場合のみ入力してください。 
     * 車両の登録
     */
    async createVehicleRaw(requestParameters: CreateVehicleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateVehicle200Response>> {
        if (requestParameters['createVehicleRequest'] == null) {
            throw new runtime.RequiredError(
                'createVehicleRequest',
                'Required parameter "createVehicleRequest" was null or undefined when calling createVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/vehicles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateVehicleRequestToJSON(requestParameters['createVehicleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateVehicle200ResponseFromJSON(jsonValue));
    }

    /**
     * 指定された車両情報を登録します。<br> 会社・営業所・ナンバープレート・メーターモードなどの情報を元に新しい車両レコードを作成します。<br> 初度登録年月および個人タクシー情報は個人タクシーの場合のみ入力してください。 
     * 車両の登録
     */
    async createVehicle(requestParameters: CreateVehicleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateVehicle200Response> {
        const response = await this.createVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CSVファイルから車両を一括登録します。 
     * 車両一括登録（CSV）
     */
    async createVehiclesCsvRaw(requestParameters: CreateVehiclesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling createVehiclesCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/vehicles/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CSVファイルから車両を一括登録します。 
     * 車両一括登録（CSV）
     */
    async createVehiclesCsv(requestParameters: CreateVehiclesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createVehiclesCsvRaw(requestParameters, initOverrides);
    }

    /**
     * 指定した車両IDのレコードを削除します。<br> 
     * 車両の削除
     */
    async deleteVehicleRaw(requestParameters: DeleteVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateVehicle200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling deleteVehicle().'
            );
        }

        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling deleteVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/vehicles/{car_id}`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateVehicle200ResponseFromJSON(jsonValue));
    }

    /**
     * 指定した車両IDのレコードを削除します。<br> 
     * 車両の削除
     */
    async deleteVehicle(requestParameters: DeleteVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateVehicle200Response> {
        const response = await this.deleteVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 車両一覧情報取得
     */
    async getVehiclesRaw(requestParameters: GetVehiclesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehiclePaginationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['radioNoKeyword'] != null) {
            queryParameters['radio_no_keyword'] = requestParameters['radioNoKeyword'];
        }

        if (requestParameters['carTypeNameKeyword'] != null) {
            queryParameters['car_type_name_keyword'] = requestParameters['carTypeNameKeyword'];
        }

        if (requestParameters['carColorNameKeyword'] != null) {
            queryParameters['car_color_name_keyword'] = requestParameters['carColorNameKeyword'];
        }

        if (requestParameters['groupNameKeyword'] != null) {
            queryParameters['group_name_keyword'] = requestParameters['groupNameKeyword'];
        }

        if (requestParameters['companyNameKeyword'] != null) {
            queryParameters['company_name_keyword'] = requestParameters['companyNameKeyword'];
        }

        if (requestParameters['salesOfficeNameKeyword'] != null) {
            queryParameters['sales_office_name_keyword'] = requestParameters['salesOfficeNameKeyword'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/vehicles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehiclePaginationResponseFromJSON(jsonValue));
    }

    /**
     * 車両一覧情報取得
     */
    async getVehicles(requestParameters: GetVehiclesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehiclePaginationResponse> {
        const response = await this.getVehiclesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 車両一覧取得（CSV）
     */
    async getVehiclesCsvRaw(requestParameters: GetVehiclesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['radioNoKeyword'] != null) {
            queryParameters['radio_no_keyword'] = requestParameters['radioNoKeyword'];
        }

        if (requestParameters['carTypeNameKeyword'] != null) {
            queryParameters['car_type_name_keyword'] = requestParameters['carTypeNameKeyword'];
        }

        if (requestParameters['carColorNameKeyword'] != null) {
            queryParameters['car_color_name_keyword'] = requestParameters['carColorNameKeyword'];
        }

        if (requestParameters['groupNameKeyword'] != null) {
            queryParameters['group_name_keyword'] = requestParameters['groupNameKeyword'];
        }

        if (requestParameters['companyNameKeyword'] != null) {
            queryParameters['company_name_keyword'] = requestParameters['companyNameKeyword'];
        }

        if (requestParameters['salesOfficeNameKeyword'] != null) {
            queryParameters['sales_office_name_keyword'] = requestParameters['salesOfficeNameKeyword'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/vehicles/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 車両一覧取得（CSV）
     */
    async getVehiclesCsv(requestParameters: GetVehiclesCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getVehiclesCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 車両情報を更新します。 
     * 車両の情報更新
     */
    async updateVehicleRaw(requestParameters: UpdateVehicleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateVehicle200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling updateVehicle().'
            );
        }

        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling updateVehicle().'
            );
        }

        if (requestParameters['updateVehicleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateVehicleRequest',
                'Required parameter "updateVehicleRequest" was null or undefined when calling updateVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }


        let urlPath = `/vehicles/{car_id}`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVehicleRequestToJSON(requestParameters['updateVehicleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateVehicle200ResponseFromJSON(jsonValue));
    }

    /**
     * 車両情報を更新します。 
     * 車両の情報更新
     */
    async updateVehicle(requestParameters: UpdateVehicleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateVehicle200Response> {
        const response = await this.updateVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CSVファイルから車両を一括更新します。 
     * 車両一括更新（CSV）
     */
    async updateVehiclesCsvRaw(requestParameters: UpdateVehiclesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling updateVehiclesCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/vehicles/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CSVファイルから車両を一括更新します。 
     * 車両一括更新（CSV）
     */
    async updateVehiclesCsv(requestParameters: UpdateVehiclesCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateVehiclesCsvRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetVehiclesSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetVehiclesSortEnum = typeof GetVehiclesSortEnum[keyof typeof GetVehiclesSortEnum];
/**
 * @export
 */
export const GetVehiclesCsvSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetVehiclesCsvSortEnum = typeof GetVehiclesCsvSortEnum[keyof typeof GetVehiclesCsvSortEnum];
